import { Grid } from "@mui/material";
import React, { useEffect, useState } from "react";

import DefaultApiService from "../../../../infrastructure/api/default";
import Dashboard from "../../../components/dashboard";
import BreadcrumbsComponent from "../../../components/shared/breadcrumbs";

const BasicInformationAdministrationPage = () => {
  const [loading, setLoading] = useState(false);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    try {
      setLoading(true);
      DefaultApiService.getApi("BI/Administration/Home/GetData", {}, true).then(
        (res) => {
          if (res?.data?.dataList) {
            setDataList(res?.data?.dataList);
            setLoading(false);
          }
        }
      );
    } catch (error) {
      setLoading(false);
    }
  }, []);

  return (
    <Grid container className="home-container" spacing={3}>
      <Grid item xs={12} md={12}>
        <BreadcrumbsComponent />
      </Grid>
      <Grid item xs={12} md={12}>
        <Dashboard blockList={dataList} loading={loading} />
      </Grid>
    </Grid>
  );
};

export default BasicInformationAdministrationPage;
